<template>
	<form class="md:max-w-80 w-full" @submit.prevent="onSubmit">
		<slot name="csrf" />
		<label for="email-subscribe" class="mb-2 text-white sr-only">Email</label>
		<div class="relative">
			<svg-vue icon="envelope" class="h-3 fill-white pointer-events-none absolute top-1/2 -translate-y-1/2" />
			<input
				type="email"
				name="email"
				id="email-subscribe"
				placeholder="Enter your email"
				class="bg-transparent !ps-6 text-white !border !border-x-0 !border-t-0 !border-b border-white focus:!ring-0 focus:!border-b-white placeholder:text-white"
				v-model="email"
				autocomplete="email"
				required
			/>
			<button
				type="submit"
				:class="[
					'!absolute right-0 top-1/2 -translate-y-1/2 transition-all ease-out duration-400',
					!email && 'opacity-0',
				]"
				:disabled="loading"
				@click.prevent="onSubmit"
			>
				<svg-vue v-if="loading" icon="spinner-third" class="h-3 fill-white animate-spin" />
				<svg-vue v-else icon="arrow-right" class="h-3 fill-white" />
			</button>
			<p v-if="success" class="text-xs text-green-200 absolute -bottom-5 left-1/2 -translate-x-1/2">{{ success }}</p>
			<p v-if="error" class="text-xs text-red-400 absolute -bottom-5 left-1/2 -translate-x-1/2">{{ error }}</p>
		</div>
		<div class="inline-flex items-center gap-4 !mt-7">
			<svg-vue icon="checkmark-outline" class="h-4.5 fill-white shrink-0" />
			<p class="text-white text-xs font-normal">
				By registering, you consent to receive emails from Seint. Seint will not sell, rent, or lease your email
				address.
			</p>
		</div>
	</form>
</template>
<script setup>
import { ref } from 'vue'
import axios from 'axios'

const props = defineProps({
	endpoint: {
		type: String,
		required: true,
	},
	groupName: {
		type: String,
		default: 'Master List',
	},
})

const { endpoint, groupName } = props
const loading = ref(false)
const success = ref(null)
const error = ref(null)
const email = ref(null)

const onSubmit = async () => {
	try {
		loading.value = true
		success.value = null
		error.value = null
		const payload = {
			email: email.value,
			groupName,
		}
		await axios.post(endpoint, payload)
		success.value = 'Successfully Subscribed!'
		loading.value = false
	} catch (err) {
		loading.value = false
		error.value = err.response?.data.message ?? 'An error occured'
	}
}
</script>
<style scoped>
input:-webkit-autofill {
	-webkit-box-shadow: 0 0 0 1000px rgb(0, 0, 0) inset !important;
	-webkit-text-fill-color: white !important;
}
</style>
